import { useEffect, useState } from "react";

import { Button, Icon_ShaprLogoRound, Modal, PlatformAPI } from "@shapr3d/frontend-lib";
import { useSearchParams } from "react-router-dom";

import thumbnail from "../../assets/images/welcome_video_thumbnail.webp";
import { useTracker } from "../../hooks/useTracker";
import { ElementClickAction, ElementClickLocation } from "../../lib/TrackingAdapter";
import { SearchParam } from "../../types";
import { PageSource } from "../../types/tracking";

import style from "./WelcomeModal.module.css";

const isShapr3DPlatform = PlatformAPI.getInstance().isShaprSupportedPlatform();

export const WelcomeModal = () => {
  const tracker = useTracker();
  const [searchParams, setSearchParams] = useSearchParams();

  const initialOpen =
    searchParams.get(SearchParam.Source) === PageSource.Signup &&
    searchParams.get(SearchParam.UTMSource) !== "app";

  const [isOpen, setIsOpen] = useState(initialOpen);
  useEffect(() => {
    if (isOpen) {
      tracker.trackWelcomeModalShown();
    }
  }, [isOpen, tracker]);

  const handleClose = () => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete(SearchParam.Source);
      return next;
    });
    setIsOpen(false);
  };

  let downloadCopy = "Download Shapr3D";
  if (!isShapr3DPlatform) {
    downloadCopy = "Download page";
  }
  let titleCopy = "Download the Shapr3D app to start editing";
  if (!isShapr3DPlatform) {
    titleCopy = "Download Shapr3D to begin";
  }

  return (
    <Modal
      fullScreenOnMobile={true}
      size="large"
      open={isOpen}
      onClose={handleClose}
      persistent={true}
      background={
        <>
          <video
            className={style.video}
            src="https://d29vl8nlkx98pf.cloudfront.net/Shapr3D_welcome_apple.mp4"
            poster={thumbnail}
            muted
            autoPlay
            playsInline
            loop
          />
          <div className={style.backdrop}></div>
        </>
      }
    >
      <div className={style.skipButton}>
        <Button
          variant="grayscale"
          onClick={() => {
            tracker.trackWelcomeModalClosed({
              reason: "skip",
            });

            handleClose();
          }}
        >
          Skip for now
        </Button>
      </div>
      <div className={style.container}>
        <Icon_ShaprLogoRound />
        <div className={style.title}>{titleCopy}</div>
        {!isShapr3DPlatform && (
          <div className={style.descriptionContainer}>
            <div className={style.description}>Check your inbox for download links.</div>
            <div className={style.description}>
              Your account works across all supported devices: iPad, Mac, Windows and Vision Pro.
            </div>
          </div>
        )}
        <Button
          className={style.buttonMargin}
          onClick={() => {
            window.open("https://www.shapr3d.com/download", "_self", "noopener,noreferrer");
            // Use existing telemetry for download action, even tho its element clicked
            tracker.trackButtonClick({
              action: ElementClickAction.GO_TO_DOWNLOAD,
              location: ElementClickLocation.WELCOME_MODAL,
            });
            tracker.trackWelcomeModalClosed({
              reason: "download",
            });

            handleClose();
          }}
        >
          {downloadCopy}
        </Button>
      </div>
    </Modal>
  );
};
